import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "components/header";
import { GlobalContext } from "./contexts/global-context";
import VolksVale from "pages/volks-vale";
import Premios from "pages/premios";
import ModalAuth from "components/modal-auth";
import ModalAuthRevendedor from "components/modal-auth-revendedor";
import Regulamento from "pages/regulamento";
import Faq from "pages/faq";
import Modal from "components/modal";

export default () => {
    const [userName, setUserName] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenRevendedor, setIsModalOpenRevendedor] = useState(false);
    const [isModalOpenWinners, setIsModalOpenWinners] = useState(false);
    const globalContextValue = {
        userName,
        setUserName,
        isModalOpenWinners,
        setIsModalOpenWinners,
    };
    return (
        <GlobalContext.Provider value={globalContextValue}>
            <Router>
                <Header
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setIsModalOpenRevendedor={setIsModalOpenRevendedor}
                />
                <Switch>
                    <Route exact={true} path="/">
                        <VolksVale
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            isModalOpenRevendedor={isModalOpenRevendedor}
                            setIsModalOpenRevendedor={setIsModalOpenRevendedor}
                            isModalOpenWinners={isModalOpenWinners}
                            setIsModalOpenWinners={setIsModalOpenWinners}
                        />
                    </Route>
                    <Route exact={true} path="/premios">
                        <Premios
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                    <Route exact={true} path="/regulamento">
                        <Regulamento
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                    <Route exact={true} path="/faq">
                        <Faq
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                        />
                    </Route>
                </Switch>
                <ModalAuth
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
                <ModalAuthRevendedor
                    isModalOpen={isModalOpenRevendedor}
                    setIsModalOpen={setIsModalOpenRevendedor}
                />
                <Modal
                    isOpen={isModalOpenWinners}
                    onClose={() => setIsModalOpenWinners(false)}
                >
                    <h2>Ganhadores</h2>
                    <table width="100%" className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th width="30%">Número da Sorte</th>
                                <th width="20%">Posição</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>JOSE ALUIZIO&nbsp;DE&nbsp;CASTRO BISNETO</td>
                                <td>02-79765</td>
                                <td>1&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>RODRIGO SILVEIRA ALVES</td>
                                <td>02-79839</td>
                                <td>2&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>TACIANA CRISTINA LIMA DA SILVA</td>
                                <td>02-79861</td>
                                <td>3&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>MAURO SERGIO MAFRA MOREIRA</td>
                                <td>02-79869</td>
                                <td>4&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>LELIA STORARI MOURAO</td>
                                <td>02-79954</td>
                                <td>5&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>ANA PAULA LAVADO</td>
                                <td>02-80049</td>
                                <td>6&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>JUDITE DA SILVA MATTOS DA SILVA</td>
                                <td>02-80059</td>
                                <td>7&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>CESAR ROMANO</td>
                                <td>02-80069</td>
                                <td>8&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>RENAN APARECIDO ALVES DOS REIS</td>
                                <td>02-80133</td>
                                <td>9&ordm; premiado</td>
                            </tr>
                            <tr>
                                <td>PAULO VITOR SERENI MURRIETA</td>
                                <td>02-80138</td>
                                <td>10&ordm; premiado</td>
                            </tr>
                        </tbody>
                    </table>
                </Modal>
            </Router>
        </GlobalContext.Provider>
    );
};
